import { render, staticRenderFns } from "./ContractFooter.vue?vue&type=template&id=e57a7e74"
import script from "./ContractFooter.vue?vue&type=script&lang=js"
export * from "./ContractFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports